import { AddressFields } from 'src/react/_util/addressPlace';
import { ContactJobState, DefaultInsured } from 'src/react/Contact';
import { AddContactCompany, BasicEmployee, Job } from 'src/types';
import { getPostInitialParamsApiData } from '../_util/getPostInitialParamsApiData';
import { postInitialParamsApi } from '../index';

export type CreateInitialParamsData = {
  company: AddContactCompany;
  employee?: Partial<BasicEmployee>;
  job?: Partial<ContactJobState | Job> | null;
  insured: Partial<DefaultInsured>;
  origin?: AddressFields;
  destination?: AddressFields;
};

export const createInitialParams = async ({ data }: { data: CreateInitialParamsData }) => {
  const initialParamsData = getPostInitialParamsApiData({ data });

  const { identifier, jobKey } = (await postInitialParamsApi({
    data: initialParamsData,
  })) as {
    identifier: string;
    jobKey: string;
  };

  return { jobKey, identifier };
};
